<template>
  <div class="form-referral">
    <div class="form-group row">
      <div
        :class="'col-md-6 form-group ' + (validations !== null && validations.hasOwnProperty('referee_name') ? 'has-error' : '')"
      >
        <label class="required">{{ $t('fields.refereeName') }}</label>
        <input
          type="text"
          class="form-control"
          v-model="referral.referee_name"
          :placeholder="$t('fields.refereeName')"
        >
        <span
          class="label-error"
          v-if="validations !== null && validations.hasOwnProperty('referee_name')"
        >
          {{ validations['referee_name'][0] }}
        </span>
      </div>
      <div
        :class="'col-md-6 form-group ' + (validations !== null && validations.hasOwnProperty('referee_phone') ? 'has-error' : '')"
      >
        <label class="required">{{ $t('fields.refereePhone') }}</label>
        <input
          type="text"
          class="form-control"
          v-model="referral.referee_phone"
          :placeholder="$t('fields.refereePhone')"
        >
        <span
          class="label-error"
          v-if="validations !== null && validations.hasOwnProperty('referee_phone')"
        >
          {{ validations['referee_phone'][0] }}
        </span>
      </div>
    </div>

    <div class="form-group row">
      <div
        :class="'col-md-6 form-group ' + (validations !== null && validations.hasOwnProperty('referred_name') ? 'has-error' : '')"
      >
        <label class="required">{{ $t('fields.referredName') }}</label>
        <input
          type="text"
          class="form-control"
          v-model="referral.referred_name"
          :placeholder="$t('fields.referredName')"
        >
        <span
          class="label-error"
          v-if="validations !== null && validations.hasOwnProperty('referred_name')"
        >
          {{ validations['referred_name'][0] }}
        </span>
      </div>
      <div
        :class="'col-md-6 form-group ' + (validations !== null && validations.hasOwnProperty('referred_phone') ? 'has-error' : '')"
      >
        <label class="required">{{ $t('fields.referredPhone') }}</label>
        <input
          type="text"
          class="form-control"
          v-model="referral.referred_phone"
          :placeholder="$t('fields.referredPhone')"
        >
        <span
          class="label-error"
          v-if="validations !== null && validations.hasOwnProperty('referred_phone')"
        >
          {{ validations['referred_phone'][0] }}
        </span>
      </div>
    </div>

    <div class="form-group row">
      <div class="col-md-12">
        <template v-if="editable">
          <button
            @click="onClickUpdate"
            class="btn btn-primary margin-right-5 btn-sm btn-update"
          >
            {{ $t('buttons.update') }}
          </button>
        </template>
        <button
          @click="onClickBack"
          class="btn btn-default btn-sm btn-back"
        >
          {{ $t('buttons.cancel') }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'FormReferral',
  props: {
    editable: {
      type: Boolean,
      default: true
    }
  },
  data () {
    return {
      referral: {
        referee_name: null,
        referee_phone: null,
        referred_name: null,
        referred_phone: null
      },
      id: null,
      validations: null
    }
  },
  computed: {
    api () {
      let action = 'store'
      if (this.$route.name === 'ReferralEdit') {
        action = 'update'
      }
      return process.env.VUE_APP_API + `/api/v1/refers/${action}`
    }
  },
  methods: {
    getReferral () {
      this.$axios.post(process.env.VUE_APP_API + '/api/v1/refers/get-refer', { id: this.id })
        .then((response) => {
          if (response.data.code === 1) {
            this.referral = response.data.data
          }
        }).catch((error) => {
          this.onResponseError(error)
        })
    },
    onClickBack () {
      this.$router.push({
        name: 'Referral'
      })
    },
    onClickUpdate () {
      const self = this
      this.$isLoading(true)
      this.$axios.post(this.api, this.referral)
        .then((response) => {
          if (response.data.code === 1) {
            this.$toastr(
              'success',
              self.$t('string.theRecordHasBeenUpdated'),
              self.$t('string.referral')
            )
            this.onClickBack()
          }
          if (response.data.code === 0) {
            this.validations = response.data.message
          }
        })
        .catch((error) => {
          this.onResponseError(error)
        })
        .finally(() => {
          this.$isLoading(false)
        })
    }
  },
  mounted () {
    this.$nextTick(() => {
      this.id = this.$route.params.id
      this.getReferral()
      if (!this.editable) {
        $('input, textarea').attr('disabled', 'disabled')
      }
    })
  }
}
</script>

<style scoped>

</style>
